module.exports = __webpack_public_path__ + "img/hmi-cross.6a3b5181.svg";